import { ApiProperty } from '@nestjs/swagger';
export class GrnVehicleInspectionInfo{
    @ApiProperty()
    rmGrnId:number;
    @ApiProperty()
    rmGrnItemId:number;
    @ApiProperty()
    indentId:number;
    @ApiProperty()
    supplierId:number;
    @ApiProperty()
    vehicleId:number;
    @ApiProperty()
    productId:number;
    @ApiProperty()
    indentNumber:string;
    @ApiProperty()
    rmVINumber:string;
    @ApiProperty()
    rmGrnNumber:string;
    @ApiProperty()
    supplierCode:string;
    @ApiProperty()
    supplierAddress:string;
    @ApiProperty()
    varietyOfMaterial:string;
    @ApiProperty()
    vehicleNumber:string;
    @ApiProperty()
    vehicleInTime:Date;
    @ApiProperty()
    sealNumber:string;
    @ApiProperty()
    icingConditionOfMaterial:string;
    @ApiProperty()
    cratesCondition:string;
    @ApiProperty()
    cleanlinessOfCrates:string;
    @ApiProperty()
    vehicleCleanliness:string;
    @ApiProperty()
    anySignOfInfestation:string;
    @ApiProperty()
    contaminationDustOrFilth:string;
    @ApiProperty()
    insulationDamage:string;
    @ApiProperty()
    remarks:string;
    @ApiProperty()
    plantId:number;
    @ApiProperty()
    createdUser:string;
    @ApiProperty()
    updatedUser:string;
    @ApiProperty()
    inspectionId:number;
    
}